var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGbtAc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 7,
    strokeLinejoin: "round",
    d: "M76.5 20        A39 39 0 1 1 23.5 20        A5.5 5.5 0 0 1 28 17.5        H72        A5.5 5.5 0 0 1 76.5 20        Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 34,
    r: 5.2,
    stroke: "#000",
    strokeWidth: 5.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 34,
    r: 5.2,
    stroke: "#000",
    strokeWidth: 5.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 54,
    r: 7,
    stroke: "#000",
    strokeWidth: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 54,
    r: 7,
    stroke: "#000",
    strokeWidth: 6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 54,
    r: 7,
    stroke: "#000",
    strokeWidth: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 76,
    r: 7,
    stroke: "#000",
    strokeWidth: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 76,
    r: 7,
    stroke: "#000",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbtAc);
export default __webpack_public_path__ + "static/media/gbt-ac.752915eb0dd940c6862afbf9796f8261.svg";
export { ForwardRef as ReactComponent };